export class SearchEvent {
  name?: string='';
  location?: string='';
  country?: string='';
  category?: string='';
  year?: string='';
  sortBy?: string='';
  user_id?: string='';
  sort_direction?: string='';
  month?: string='';
  day?: string='';
  time?: string='';
  timeSearch?: string='';
  start_date?: string='';
  end_date?: string='';

  constructor(){}
}
